import { parseMixRouteThreadSlug } from "@/shared/lib/threadRoutePath";

const BOARD_SLUG_SEGMENT = "[a-z0-9](?:[a-z0-9-]{0,30}[a-z0-9])?";
const BOARD_SLUG_PATTERN = new RegExp(`^${BOARD_SLUG_SEGMENT}$`);
const BOARD_MOUNT_SLUG_PATTERN = new RegExp(
  `^/b/(${BOARD_SLUG_SEGMENT})(?:/|$)`,
);

/**
 * 公開URLのpathnameから、その画面が直接対象にしている板slugを取り出す。
 * 板mountとmix内の板slug付きスレッドを扱い、総合面など対象板を1つに
 * 決められないURLではnullを返す。
 */
export function resolveCurrentUrlSlug(pathname: string): string | null {
  const boardMountSlug = BOARD_MOUNT_SLUG_PATTERN.exec(pathname)?.[1];
  if (boardMountSlug !== undefined) return boardMountSlug;
  if (!pathname.startsWith("/mix/")) return null;

  const mixThreadSlug = parseMixRouteThreadSlug(pathname.slice("/mix".length));
  return mixThreadSlug !== undefined && BOARD_SLUG_PATTERN.test(mixThreadSlug)
    ? mixThreadSlug
    : null;
}
